<template>
  <div class="container">
    <HomePage />
  </div>
</template>

<script>
import HomePage from '@/components/home/HomePage'

export default {
  name: 'base-view',
  components: {
    HomePage,
  },
  data: function () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
